import AdministratorPanel from "@components/AdministratorPanel";
import AppBar from "@components/AppBar";
import Chat from "@components/Chat";
import Sidebar from "@components/Sidebar/Sidebar";
import LayoutDefault from "@layouts/LayoutDefault";
import ChatIcon from "@mui/icons-material/Chat";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { Box } from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import { useState } from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface TabConfig {
  value: number;
  labelKey: string;
  icon: React.ReactElement;
  component: React.ReactNode;
  hasAccess: boolean;
}

const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2, height: "100%" }}>{children}</Box>}
    </div>
  );
};

const MainView = () => {
  // Pestaña por defecto: Chat (índice 1), accesible siempre
  const [value, setValue] = useState(1);

  const { keycloak } = useKeycloak();

  const hasAdminAccess = keycloak.hasRealmRole("ispd_ui_administrator");

  const tabs: TabConfig[] = [
    {
      value: 0,
      labelKey: "administration.title",
      icon: <ManageAccountsIcon />,
      component: <AdministratorPanel />,
      hasAccess: hasAdminAccess
    },
    {
      value: 1,
      labelKey: "home.chat",
      icon: <ChatIcon />,
      component: <Chat />,
      hasAccess: true // Always visible because the default tab
    }
  ];

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <LayoutDefault title="Lighthouse">
      <Box
        sx={{
          display: "flex",
          width: "100%",
          height: "100%",
          backgroundColor: "#f6f6f6",
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      >
        {/* Sidebar */}
        <Sidebar value={value} handleChange={handleChange} tabs={tabs} />
        {/* Content */}
        <Box width={"100%"}>
          <AppBar />

          <Box
            sx={{
              flexGrow: 1,
              overflow: "auto",
              alignSelf: "center",
              height: "calc(100% - 130px)"
            }}
          >
            {tabs.map(
              (tab, index) =>
                tab.hasAccess && (
                  <CustomTabPanel key={index} value={value} index={tab.value}>
                    {tab.component}
                  </CustomTabPanel>
                )
            )}
          </Box>
        </Box>
      </Box>
    </LayoutDefault>
  );
};

export default MainView;
